import { Service, inject } from '@angular/core';

import { type CompanySecondStepPrefill } from '@protctc/common/core/models/company/company';

import { AddressMapper } from '../address/address.mapper';
import { type CompanySecondStepPrefillDto } from '../dto/company/company.dto';
import { type IMapperFromDto } from '../mappers';

/** Company second step prefill mapper. */
@Service()
export class CompanySecondStepPrefillMapper implements IMapperFromDto<CompanySecondStepPrefillDto, CompanySecondStepPrefill> {
	private readonly addressMapper = inject(AddressMapper);

	/** @inheritdoc */
	public fromDto(data: CompanySecondStepPrefillDto): CompanySecondStepPrefill {
		return {
			ownerFirstName: data.owner_first_name,
			ownerLastName: data.owner_last_name,
			email: data.email,
			phone: data.phone,
			address: this.addressMapper.fromDto(data),
			token: { key: '' },
		};
	}
}
